import { render, staticRenderFns } from "./NpaDevelopers.vue?vue&type=template&id=60c649ca"
import script from "./NpaDevelopers.vue?vue&type=script&lang=js"
export * from "./NpaDevelopers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports